import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6458ddba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6458ddba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458ddba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6458ddba')) {
      api.createRecord('6458ddba', component.options)
    } else {
      api.reload('6458ddba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6458ddba&scoped=true", function () {
      api.rerender('6458ddba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Weforsys-table-draggables/index.vue"
export default component.exports